module.exports = __webpack_public_path__ + "img/d2.c9da40a1.jpg";